import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { encryptTransform } from 'redux-persist-transform-encrypt';

import userReducer from '../features/userSlice';
import whiseTokenReducer from '../features/WhiseTokenSlice';
import selectedPropertyReducer from '../features/SelectedPropertySlice';
import agentFilterReducer from '../features/AgentFilterSlice';
import statusFilterReducer from '../features/StatusFilterSlice';
import createEventDetailSlice from '../features/CreateEventDetailSlice';
import SettingReducer from '../features/SettingSlice';
import CalendarActionsReducer from '../features/ClientCalendarActionsSlice';
import ClientTokenReducer from '../features/ClientTokenSlice';
import CalendarViewReducer from '../features/CalendarSelectedViewSlice';
import SidebarCollapseReducer from '../features/SidebarCollapseSlice';
import QuestionDetailReducer from '../features/QuestionDetailSlice';
import LanguagesReducer from '../features/LanguageSlice';
import estateConfigurationReducer from '../features/EstateConfigurationSlice';
import selectedLanguageTranslationsReducer from '../features/SelectedLanguageTranslationsSlice';
import bookAbleUntilReducer from "../features/BookAbleUntilSlice";
import DuplicateTimeSlotsReducer from "../features/DuplicateTimeSlotSlice";
import ScheduleTimeSlotDetailReducer from "../features/ScheduleTimeSlotDetailSlice";
import ActiveEstateListReducer from "../features/ActiveEstateList";
import UserAccountTypeReducer from "../features/UserAccountTypeSlice";
import ClientWhiseTokenByAccountTypeReducer from "../features/ClientWhiseTokenByAccountTypeSlice";
import fetchLatestRecordReducer from "../features/FetchLatestRecordSlice";
import AllEstatesListReducer from "../features/AllEstatesListSlice";
import EstateStatusListReducer from "../features/EstateStatusListSlice";
import WaitingListStatusReducer from "../features/WaitingListStatus";
import ShowEditEstateConfigModalReducer from "../features/ShowEditEstateConfigModal";
import ShowWaitingAndEventsModalReducer from "../features/ShowWaitingAndEventsModal";
import ShowHistoryTabModalReducer from "../features/ShowHistoryTabSlice";
import RenderAppReducer from "../features/RenderApp";

import storage from 'redux-persist/lib/storage';

import {
    persistReducer, persistStore,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER } from 'redux-persist';
import storageSession from 'redux-persist/es/storage/session';

//const encryptor = encryptTransform({
//    secretKey: 'abc',
//    onError: function (error) { console.log(error); }
//});

const rootReducer = combineReducers({
    user: userReducer,
    whiseUser: whiseTokenReducer,
    selectedProperty: selectedPropertyReducer,
    agentFilter: agentFilterReducer,
    statusFilter: statusFilterReducer,
    eventDetail: createEventDetailSlice,
    setting: SettingReducer,
    calendarActions: CalendarActionsReducer,
    whiseClientToken: ClientTokenReducer,
    calendarView: CalendarViewReducer,
    isSideBarCollapsed: SidebarCollapseReducer,
    questionDetail: QuestionDetailReducer,
    allLanguages: LanguagesReducer,
    estateConfiguration: estateConfigurationReducer,
    selectedLanguageTranslations: selectedLanguageTranslationsReducer,
    bookAbleUntil: bookAbleUntilReducer,
    duplicateTimeSlots: DuplicateTimeSlotsReducer,
    scheduleTimeSlotsDetail: ScheduleTimeSlotDetailReducer,
    activeEstateList: ActiveEstateListReducer,
    userAccountType: UserAccountTypeReducer,
    clientWhiseTokenByAccountType: ClientWhiseTokenByAccountTypeReducer,
    fetchLatestRecord: fetchLatestRecordReducer,
    allEstatesList: AllEstatesListReducer,
    estateStatusList: EstateStatusListReducer,
    waitingListEnabled: WaitingListStatusReducer,
    showEditEstateConfigModal: ShowEditEstateConfigModalReducer,
    showWaitingAndEventsModal: ShowWaitingAndEventsModalReducer,
    showHistoryTabModal: ShowHistoryTabModalReducer,
    renderApp: RenderAppReducer
})

const persistConfig = {
    key: 'root',
    storage: storageSession,
   // transforms: [encryptor],   // ← encrypts everything in sessionStorage
    blacklist: ['questionDetail', 'estateConfiguration']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
})

export const persistor = persistStore(store);